import React, { useState } from "react";
import { Radio, Card, Row, Col } from "antd";
import EnrollmentDetails from "./EnrolmentDetails";
import ListView from "./ListView";
import UploadEnrollment from "./UploadEnrolment";
import { useSelector } from "react-redux";
import { getUserData } from "../login/LoginSlice";
import "./enrolment.css";

// Define report options with their corresponding option IDs
const EnrollmentOptions = [
  { value: 0, label: "Enrollment Details", optionId: 2 },
  { value: 1, label: "List View", optionId: 2 },
  { value: 2, label: "Upload Enrollment", optionId: 3 },
];

const Index = () => {
  const [activeComponent, setActiveComponent] = useState(0);
  const [heading, setHeading] = useState("Enrollment Details");
  const Data = useSelector(getUserData);


  const userModule = Data?.module_data?.find((module) => module.module_id === 2);
  const userOptionIds = userModule?.module_option_ids || [];
  console.log("Allowed Option IDs:", userOptionIds);

  // Handle component change
  const handleComponentChange = (e) => {
    const component = e.target.value;
    setActiveComponent(component);
    setHeading(EnrollmentOptions.find((option) => option.value === component)?.label || "Enrollment Details");
  };

  return (
    <div>
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            className="cust-cd-card mb-3"
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                <span className="corp-title">{heading}</span>

                <Radio.Group
                  block
                  onChange={handleComponentChange}
                  defaultValue={0}
                  buttonStyle="solid"
                  optionType="button"
                >
                  {EnrollmentOptions.map(({ value, label, optionId }) => (
                    <Radio key={value} value={value} disabled={!userOptionIds.includes(optionId)}>
                      {label}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            }
            bordered={false}
          ></Card>

          {activeComponent === 0 && <EnrollmentDetails />}
          {activeComponent === 1 && <ListView />}
          {activeComponent === 2 && <UploadEnrollment />}
        </Col>
      </Row>
    </div>
  );
};

export default Index;

